import React, { SyntheticEvent, useContext } from "react";
import { Dropdown } from "@cmsgov/ds-medicare-gov";
import { useTranslate, sendTealiumEvent } from "../../helpers";
import { AppStore } from "../../app/store";
import { ActionType } from "../../@types";
import { defaultState } from "../../app/store/AppStore";

const CarrierFilter: React.FunctionComponent<{
  onCarrierUpdate: (carrier: string) => void;
}> = ({ onCarrierUpdate }) => {
  const {
    state: { searchResultsFilters = defaultState.searchResultsFilters },
    dispatch,
  } = useContext(AppStore.AppContext);
  const { insuranceCarrier, insuranceCarriers } = searchResultsFilters;
  const t = useTranslate();

  return (
    <Dropdown
      onChange={(ev: SyntheticEvent<HTMLSelectElement>): void => {
        // istanbul ignore next: tested elsewhere
        sendTealiumEvent(
          "Find Plans - Available Plans",
          "Insurance Carrier Pull down"
        );
        dispatch({
          type: ActionType.UPDATE_SEARCH_RESULTS_FILTERS,
          payload: {
            ...searchResultsFilters,
            insuranceCarrier: ev.currentTarget.value,
          },
        });
        onCarrierUpdate(ev.currentTarget.value);
      }}
      name="preferred-insurance-carrier"
      value={insuranceCarrier}
      label={t("plan_terms.insurance_carrier")}
      id="preferred-insurance-carrier"
      options={[]}
    >
      <option value="" aria-selected={!insuranceCarrier}>
        {t("app.terms.select_preferred_insurance_carrier")}
      </option>
      {insuranceCarriers.map((carrier, index) => (
        <option value={carrier} key={index}>
          {carrier}
        </option>
      ))}
    </Dropdown>
  );
};

export default CarrierFilter;
